import Swal from 'sweetalert2'
import {
    IS_LOADING_VIEW_NOTIFICATION,
    DELETE_NOTIFICATION_ADDRESSEE, NOTIFICATIONS_ADDRESSEE,
    VIEW_NOTIFICATION, IS_LOADING_NOTIFICATIONS_ADDRESSEE, ADD_NOTIFICATIONS_ADDRESSEE, IS_LOADING_CONFIGURATION_NOTIFICATIONS, CONFIGURATION_NOTIFICATION,
    IS_LOADING_CHANGE_CONFIGURATION_NOTIFICATION, CHANGE_CONFIGURATION_NOTIFICATION
} from './types'

import {
    urlServer
} from '../config/GlobalConstant'
import inMemoryJWT from '../auth/inMemoryJwt';
import localStorage from '../utils/hooks/useLocalStorage';

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1000
})

export const getNotificationsAddressee = (isProfessional) => async dispatch => {

    await fetch(`${urlServer}notifications/get-notifications-addressee`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header   
        body: JSON.stringify({
         
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_NOTIFICATIONS_ADDRESSEE
                })
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: NOTIFICATIONS_ADDRESSEE,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const addNotification = (data) => async dispatch => {
    dispatch(getNotificationsAddressee())
   /*  dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_NOTIFICATIONS_ADDRESSEE
    });
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: ADD_NOTIFICATIONS_ADDRESSEE,
        payload: data.bodyNotification
    }); */
}

export const viewNotification = (id, nextStep, isEnableContent) => async dispatch => {

   /*  dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_NOTIFICATIONS_ADDRESSEE
    }); */
    
    await fetch(`${urlServer}notifications/view-notification`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header   
        body: JSON.stringify({ notificationId: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {

         
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: VIEW_NOTIFICATION,
                    payload: id
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const deleteNotification = (id, index, history) => async dispatch => {

    await fetch(`${urlServer}notifications/delete-notification`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header   
        body: JSON.stringify({ notificationId: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_NOTIFICATIONS_ADDRESSEE
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_NOTIFICATION_ADDRESSEE,
                    payload: respJson.data._id
                });
            }
        })
        .catch(error => {
            console.log()
        })
}


export const disableNotification = (id, index, history) => async dispatch => {

    await fetch(`${urlServer}api/notifications/disable-enable-post-notification`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header   
        body: JSON.stringify({
            postId: "lkhkh76RF6d65d65",
            // professionalPostId:"lkhkh76RF6d65d65",
            enable: true
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_NOTIFICATIONS_ADDRESSEE
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_NOTIFICATION_ADDRESSEE,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}


export const disableEnableUserNotification = (index, typeNotifications, enable, history) => async dispatch => {

    await fetch(`${urlServer}api/notifications/disable-enable-notification`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header   
        body: JSON.stringify({ entityID: localStorage().getItem('idUser'), nameDisable: typeNotifications, enable: enable })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_NOTIFICATIONS_ADDRESSEE
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_NOTIFICATION_ADDRESSEE,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getUserNotificationsOptions = (secondID, isProfessional, history) => async dispatch => {

    await fetch(`${urlServer}api/social/${isProfessional ? 'get-professional-notifications-options' : 'get-user-notifications-options'}`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header   
        body: JSON.stringify({ firstID: localStorage().getItem('idUser'), secondID: secondID })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_CONFIGURATION_NOTIFICATIONS
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: CONFIGURATION_NOTIFICATION,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getUserEnableDisableNotifications = (secondID, enableOrDisable, isProfessional, history) => async dispatch => {

    await fetch(`${urlServer}api/social/${isProfessional ? 'professional-disable-notifications' : 'disable-notifications'}`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header   
        body: JSON.stringify({ firstID: localStorage().getItem('idUser'), secondID: secondID, enableOrDisable: enableOrDisable })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_CHANGE_CONFIGURATION_NOTIFICATION
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: CHANGE_CONFIGURATION_NOTIFICATION,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}